import React, { Component } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { verifyPassword } from '../actions';
import withValidatePassword from '../../common/hoc/withValidatePassword';
import logo from '../../../../images/logo.svg';

class ResetPasswordPage extends Component {
  static propTypes = {
    validatePasswordForUserKind: PropTypes.func.isRequired,
    verifyPassword: PropTypes.func.isRequired,
    passwordToken: PropTypes.string.isRequired,
    validatePasswordWarning: PropTypes.string.isRequired,
    kind: PropTypes.string,
  }

  static defaultProps = {
    kind: null,
  }

  state = {
    error: '',
    response: '',
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { password, repeatPassword } = this;
    if (password.value !== repeatPassword.value) {
      this.setState({
        error: 'Passwords do not match!',
      });
    } else {
      const data = {
        passwordResetToken: this.props.passwordToken,
        password: password.value,
        login: true,
      };
      this.props.verifyPassword(data);
    }
  };

  clearValidation = () => {
    this.setState({
      error: '',
    });
  }

  render() {
    const { error, response } = this.state;
    const { validatePasswordWarning, validatePasswordForUserKind } = this.props;

    return (
      <form onSubmit={this.onSubmit} className="c-inner-wrapper u-max-width-400 u-position-relative u-mt++">
        <div className="c-logo-login">
          <img src={logo} alt="Squire" />
        </div>
        <div className="c-heading c-heading--semibold c-heading--large u-text-center u-mv">SET PASSWORD</div>
        <div className="c-login-error-message" display-if={response}>{response}</div>
        <div className="c-label-new">New Password</div>
        <input
          ref={(input) => { this.password = input; }}
          type="password"
          className="c-input c-input--large u-pl-"
          placeholder="New password"
          name="password"
          onClick={this.clearValidation}
          onChange={validatePasswordForUserKind(this.props.kind)}
        />
        <div className="u-font-color-red zeta" display-if={validatePasswordWarning}>
          {validatePasswordWarning}
        </div>
        <div className="u-position-relative">
          <div className="c-label-new u-mt">Repeat Password</div>
          <input
            ref={(input) => { this.repeatPassword = input; }}
            type="password"
            className="c-input c-input--large u-pl-"
            placeholder="Repeat password"
            name="newPassword"
            onClick={this.clearValidation}
          />
          {error ? <div className="c-input-error-message">{error}</div> : ''}
        </div>
        <div className="o-flexbox u-pt">
          <button type="submit" className="c-btn" style={{ margin: 'auto' }}>
            <span className="c-btn__text">Set my password</span>
          </button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  resetPasswordResponse: state.auth.resetPasswordResponse,
  passwordToken: ownProps.params.token,
  kind: ownProps.location.query.kind,
});

const mapDispatchToProps = {
  verifyPassword,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withValidatePassword,
)(ResetPasswordPage);
